var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M23.001 12.2331C23.001 11.3698 22.9296 10.7398 22.7748 10.0864H12.7153V13.983H18.62C18.501 14.9514 17.8582 16.4097 16.4296 17.3897L16.4096 17.5202L19.5902 19.9349L19.8106 19.9564C21.8343 18.1247 23.001 15.4297 23.001 12.2331Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M12.7147 22.5001C15.6075 22.5001 18.0361 21.5667 19.8099 19.9567L16.429 17.39C15.5242 18.0083 14.3099 18.44 12.7147 18.44C9.88142 18.44 7.47669 16.6083 6.61947 14.0767L6.49382 14.0871L3.18656 16.5955L3.14331 16.7133C4.90519 20.1433 8.52423 22.5001 12.7147 22.5001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M6.61997 14.0767C6.39379 13.4234 6.26289 12.7233 6.26289 12C6.26289 11.2767 6.39379 10.5767 6.60807 9.92337L6.60208 9.78423L3.25337 7.2356L3.14381 7.28667C2.41765 8.71002 2.00098 10.3084 2.00098 12C2.00098 13.6917 2.41765 15.29 3.14381 16.7133L6.61997 14.0767Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M12.7148 5.55997C14.7267 5.55997 16.0838 6.41163 16.8576 7.12335L19.8814 4.23C18.0243 2.53834 15.6076 1.5 12.7148 1.5C8.52426 1.5 4.9052 3.85665 3.14331 7.28662L6.60759 9.92332C7.47672 7.39166 9.88146 5.55997 12.7148 5.55997Z",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.046ac6740811e22c06613602eedf1b88.svg";
export { ForwardRef as ReactComponent };